import { useEffect, useRef } from 'react';

export default (callback, delay) => {
    const savedCallback = useRef(null);
    const pollCount = useRef(0);

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
        pollCount.current = 0;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        const tick = () => {
            pollCount.current = pollCount.current + 1;
            savedCallback.current(pollCount.current);
        };
        if (delay !== null) {
            let id = setTimeout(tick, delay);
            return () => clearTimeout(id);
        }
    }, [delay]);
}
